'use client';

import { useEffect, useState } from 'react';
import supabase from '@/lib/supabase';
import useAuthStore from '@/store/useAuthStore';
import { getCanonicalProfileRole } from '@/lib/profile-role';

export default function useHasParentAccount(enabled = true) {
  const user = useAuthStore((s) => s.user);
  const profile = useAuthStore((s) => s.profile);
  const [hasParent, setHasParent] = useState(false);
  const [parentEmail, setParentEmail] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !user?.id || getCanonicalProfileRole(profile) !== 'student') {
      setHasParent(false);
      setParentEmail(null);
      return;
    }

    let cancelled = false;

    supabase
      .from('parent_child_relationships')
      .select('parent_id, profiles!parent_child_relationships_parent_id_fkey(email)')
      .eq('child_id', user.id)
      .limit(1)
      .then(({ data }) => {
        if (!cancelled) {
          const row = data?.[0];
          setHasParent(Boolean(row));
          setParentEmail((row as any)?.profiles?.email ?? null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, profile, user?.id]);

  return { hasParent, parentEmail };
}
